import { render } from "./CardBasics.vue?vue&type=template&id=e6c6193c&scoped=true"
import script from "./CardBasics.vue?vue&type=script&lang=js"
export * from "./CardBasics.vue?vue&type=script&lang=js"

import "./CardBasics.vue?vue&type=style&index=0&id=e6c6193c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c6193c"]])

export default __exports__